module.exports = __webpack_public_path__ + "img/smart_mirror_logo_w.726d4b31.svg";